/* eslint-disable global-require,import/no-unresolved,max-len */
import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'react-native'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import CommunicatorSetupStep from './CommunicatorSetupStep'
import textStyles from '../../styles/text'
import DataSendingLightsDiagram from './DataSendingLightsDiagram'
import * as helpers from '../../actions/helpers'
import { trackEventAndNavigate } from '../../actions/helpers'

function USBCellularAdapterSetup4(props) {
  const { t, trackEventAndPop } = props
  return (
    <CommunicatorSetupStep
      stepsImage="step4"
      heading={t('common:usbCellularAdapter')}
      title={t('usbCellularStep4Title')}
      setupImage="usb_cellular_step_4"
      paragraphs={
        [
          <Text style={textStyles.bodyContentText}>{t('common:step3Paragraph1')}</Text>,
          <Text style={textStyles.bodyContentTextBold}>{t('usbCellularStep4Paragraph2')}</Text>,
          <Text style={textStyles.bodyContentText}>{t('usbCellularStep4Paragraph3')}</Text>,
          <DataSendingLightsDiagram t={t} />,
          <Text style={textStyles.bodyContentText}>{t('usbCellularStep4Paragraph4')}</Text>,
        ]
      }
      nextTapped={() => trackEventAndNavigate('USBCellularStep5Page', 'next')}
      accessibilityLabel={t('access:cellAdapterStep4Page')}
      testID="USBCellularSetup4"
      moreInformationAnalyticsEventDescription="USBCellularStep4"
      trackEventAndPop={trackEventAndPop}
      t={t}
    />
  )
}

USBCellularAdapterSetup4.propTypes = {
  trackEventAndPop: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

const actionCreators = { trackEventAndPop: helpers.trackEventAndPop }

export const USBCellularAdapterSetup4Component = USBCellularAdapterSetup4

export default withTranslation(['communicatorSetup', 'common'])(connect(null, actionCreators)(USBCellularAdapterSetup4))
